import type { Ref } from 'vue'
import type { UseBulkActionToolbarComposable } from './epb-bulk-actions.types'
import { DomainArrayUtils } from '@empathyco/playboard-core-domain'
import { deepEqual } from '@empathyco/x-utils'
import { provide, ref } from 'vue'
import { BULK_ACTION_PROVIDER_KEY } from './consts'

export function initBulkActionProvider<T extends object>(): UseBulkActionToolbarComposable<T> {
  const selectedItems: Ref<Array<T>> = ref([])
  const isToolBarOpen: Ref<boolean> = ref(false)

  function selectItem(item: T): void {
    selectedItems.value.push(item)
  }

  function unSelectItem(item: T): void {
    selectedItems.value = selectedItems.value.filter(selectedItem => !deepEqual(selectedItem, item))
  }

  function clearAllSelectedItems(): void {
    selectedItems.value = []
  }

  function isSelected(item: T): boolean {
    return selectedItems.value.some(selectedItem => deepEqual(selectedItem, item))
  }

  function toggleToolbar(): void {
    isToolBarOpen.value = !isToolBarOpen.value
    clearAllSelectedItems()
  }

  function selectAll(items: Array<T>): void {
    if (DomainArrayUtils.containSameElements(selectedItems.value, items)) {
      clearAllSelectedItems()
    } else {
      selectedItems.value = items.slice()
    }
  }

  const actions: UseBulkActionToolbarComposable<T> = {
    isToolBarOpen,
    selectedItems,
    selectItem,
    clearAllSelectedItems,
    toggleToolbar,
    isSelected,
    unSelectItem,
    selectAll,
  }

  provide<UseBulkActionToolbarComposable<T>>(BULK_ACTION_PROVIDER_KEY, actions)

  return actions
}
